import React from "react";
import UserNameForm from "./UserNameForm";

export const About = () => {
  return (
    <>
      <h1>about</h1>
      <UserNameForm />
    </>
  );
};
